'use client';

import { useEffect, useRef, useState } from 'react';
import { useAuthContext } from '@r-and-a-shared-ui/auth-client';

export const useRecheckAuthOnNavigate = (key?: string, enabled = true) => {
  const { userState } = useAuthContext();
  const { checkAuthStatus, hasCheckedAuth } = userState;
  const [isVerifyingAuth, setIsVerifyingAuth] = useState(enabled);
  const recheckAuth = useRef(hasCheckedAuth);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (!recheckAuth.current) {
      recheckAuth.current = true;
      setIsVerifyingAuth(false);

      return;
    }

    setIsVerifyingAuth(true);

    checkAuthStatus().finally(() => {
      setIsVerifyingAuth(false);
    });
  }, [key, checkAuthStatus, enabled]);

  return { isVerifyingAuth };
};
